<template>
  <v-btn
    :type="type"
    :disabled="disabled"
    class="btn-dateils"
    @click="evOnClick"
  >
    <i class="fas fa-file-upload mr-2 text-twenty"></i>
    {{ loading ? "CARREGANDO" : text }}
  </v-btn>
</template>

<script>
export default {
  name: "VBtnImport",

  props: {
    type: { type: String, default: "button" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    text: { type: String, default: "IMPORTAR" },
  },

  methods: {
    async evOnClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style>
</style>